import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryState } from './state/history.state';
import { NgxsModule } from '@ngxs/store';

@NgModule({
  declarations: [],
  imports: [
    NgxsModule.forFeature([
      HistoryState
    ]),

    CommonModule
  ]
})
export class HistoryModule { }
